import React, {Component} from 'react'
import {CSSTransition, TransitionGroup} from 'react-transition-group'
import CloseBtn from '../../components/CloseBtn'
import InnerWrap from './Wrap'
import MapSection from '../../components/MapSection'
import MapLocation from '../../components/MapSection/MapLocation'
import BackSound from '../../components/BackSound'
import * as routes from '../../const/routes'
import * as videos from '../../const/videos'
import {withUiContext} from "../../UiContext";
import MenuBtn from "../../components/MenuBtn";
import NavContent from "../../components/NavContent";
import {locationsPoints} from '../../const/projects';
import Languages from '../../const/languages'

class Project extends Component {

    state = {
        driver: this.props.ui.driver,
        navContent: false,
        thisProjects: null,
        popup: {
            type: null,
            opened: false,
            data: null,
        }
    }

    toggleNav = (e) => {
        this.setState((prevState) => ({navContent: !prevState.navContent}))
    }

    onEnded = () => {
        this.setState({driver: false})
    }

    render() {
        const { driver, navContent } = this.state

        return (
            <InnerWrap
                video={videos.map_out_cycle}
                driverVideo={videos.map_out}
                driver={driver}
                title={driver ? null : Languages.projects}
                onEnded={this.onEnded}
            >
                <div className="hud__container-content">
                    {!driver && (
                        <MenuBtn className={`animated ${!navContent ? 'fadeInLeft' : 'fadeOutLeft'}`} onClick={this.toggleNav} onMouseEnter={this.props.ui.playOverSound}/>
                    )}

                    <TransitionGroup className="menu-outer">
                        {navContent &&
                        <CSSTransition timeout={300} classNames="menu-transition">
                            <NavContent onClose={this.toggleNav}/>
                        </CSSTransition>
                        }
                    </TransitionGroup>

                    { !driver && (
                        <MapSection>
                            { locationsPoints && locationsPoints.map((item, index) => {
                                const { locationId, coordinates, rotate } = item;

                                return (
                                    <MapLocation
                                        key={index}
                                        link={routes[`PROJECT_LOCATION_${locationId}`]}
                                        style={{left: coordinates.x, top: coordinates.y, transform: `rotate(${rotate}deg)`}}
                                    />
                                )
                            })}
                        </MapSection>
                    )}
                </div>

                <div className="hud__container-controls">
                    {!driver && (
                        <BackSound navContent={navContent} />
                    )}

                    <CloseBtn
                        link={routes.HOME}
                        driverStatus
                    />
                </div>
            </InnerWrap>
        )
    }
}

export default withUiContext(Project)
